import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../context/UserContext'
import { resetAPISState } from '../services/api/api'

export const useLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setUser } = useUser()

  const logout = () => {
    window.localStorage.removeItem('aiot_t')
    window.localStorage.removeItem('username')
    setUser(null)
    resetAPISState(dispatch)
    navigate('/login')
  }

  return logout
}
